import React, { useRef, useState } from "react";
type Props = React.HTMLAttributes<HTMLDivElement> & {
  children: React.ReactNode;
};

const minimizedHeight = 50;

const AttendeesWrapper: React.FC<Props> = ({ children, ...rest }) => {
  const [height, setHeight] = useState(200); // başlangıç yüksekliği
  const isResizing = useRef(false);
  const startY = useRef(0);
  const startHeight = useRef(0);
  const overlayRef = useRef<HTMLDivElement>(null);

  const handleMouseDown = (e: React.MouseEvent<HTMLDivElement>) => {
    isResizing.current = true;
    startY.current = e.clientY;
    startHeight.current = height;
    document.body.style.userSelect = "none";

    document.body.style.pointerEvents = "none";
    if (overlayRef.current) {
      overlayRef.current.style.display = 'block';
    }

    // move ve up event'lerini window'a bağla
    window.addEventListener("mousemove", handleMouseMove);
    window.addEventListener("mouseup", handleMouseUp);
  };

  const handleMouseMove = (e: MouseEvent) => {
    if (!isResizing.current) return;
    const delta = e.clientY - startY.current;
    setHeight(startHeight.current - delta); // yukarı çıkınca yükseklik artsın
  };

  const handleMouseUp = () => {
    isResizing.current = false;
    document.body.style.userSelect = "";
    document.body.style.pointerEvents = "";
    if (overlayRef.current) {
      overlayRef.current.style.display = 'none';
    }
    window.removeEventListener("mousemove", handleMouseMove);
    window.removeEventListener("mouseup", handleMouseUp);
  };

  return (
    <div
      className={rest.className}
      style={{
        height,
      }}
    >
      <div
        ref={overlayRef}
        style={{
          position: 'fixed',
          top: 0,
          left: 0,
          width: '100%',
          height: '100%',
          zIndex: 9999,
          cursor: 'ns-resize',
          display: 'none',
          backgroundColor: "rgba(0,0,0,.05)"
        }}
      />
      <div className="flex justify-end mb-1">
        {height === minimizedHeight ? <div
          onClick={() => setHeight(300)}
          className="bg-amber-400 text-black py-1 px-3 rounded text-sm font-semibold"
        >
          Büyüt
        </div> : <div
          onClick={() => setHeight(minimizedHeight)}
          className="bg-amber-400 text-black py-1 px-3 rounded text-sm font-semibold"
        >
          Küçült
        </div>}
      </div>
      <div
        onMouseDown={handleMouseDown}
        className="h-5 pt-2 cursor-ns-resize absolute inset-0 z-1 hover:bg-white/30 transition-all"
      >
        <div className="h-1 w-full bg-myOrange" />
      </div>
      {children}
    </div>
  );
};

export default AttendeesWrapper;
